import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CopyFile"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 15H6V4.5H16.5V3H6C5.17192 3.00083 4.50083 3.67192 4.5 4.5V15ZM16.0328 6.4335L20.5763 11.0243C20.8469 11.3003 20.999 11.6712 21 12.0577V21.75C20.9992 22.5781 20.3281 23.2492 19.5 23.25H9C8.17192 23.2492 7.50083 22.5781 7.5 21.75V7.5C7.50083 6.67192 8.17192 6.00083 9 6H14.9985C15.3872 6.00125 15.7593 6.15724 16.0328 6.4335ZM15 7.52249L19.443 12H15V7.52249ZM9 7.5V21.75H19.5008L19.5 13.5H15C14.1719 13.4992 13.5008 12.8281 13.5 12V7.5H9Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CopyFile.vue"]]);
